import { Avatar, Radio } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import React from "react";
import { externalLinkImage } from "../../../../../assets";
import { S3baseUrl } from "../../../../../bl_libs/ApiCalling";

function UserCard(props) {
  const {
    CompanyDetails,
    HitCompanyActivate,
    HitCompanyDeactivate,
    HitCompanyApprove,
  } = props;

  const {
    email,
    phone,
    is_active,
    name,
    address,
    profile_picture,
    about_company,
    bank_id,
    ca_number,
    dot_number,
    mtr_number,
    pli_file_path,
    pdi_file_path,
    cpi_file_path,
    gli_file_path,
    wc_file_path,
    company_rating,
    registeration_status,
  } = CompanyDetails;

  return (
    <>
      <div className="form-group text-center pt-4">
        {
          //if preview is empty show default
          profile_picture ? (
            //if profile picture is available show profile
            <img
              src={S3baseUrl + profile_picture}
              className="circle-box rounded-circle edit-profile-img"
            />
          ) : (
            //else show default picture
            <Avatar
              style={{
                width: 150,
                height: 150,
                fontSize: 22,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            ></Avatar>
          )
        }
        <div className="pt-3">
          <Rating
            value={company_rating ? company_rating : 0}
            readOnly
            precision={0.1}
          />
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Name:</div>
        <div className="col-7 text-left black-color">{name}</div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Email:</div>
        <div className="col-7 text-left black-color">{email}</div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Phone:</div>
        <div className="col-7 text-left black-color">{phone}</div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">About Company:</div>
        <div className="col-7 text-left black-color">
          {about_company ? about_company : "N/A"}
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Address:</div>
        <div className="col-7 text-left black-color">{address}</div>
      </div>
      {/* <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Bank ID:</div>
        <div className="col-7 text-left black-color">{bank_id}</div>
      </div>{" "} */}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">CA Number:</div>
        <div className="col-7 text-left black-color">{ca_number}</div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">DOT Number:</div>
        <div className="col-7 text-left black-color">{dot_number}</div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">MTR Number:</div>
        <div className="col-7 text-left black-color">{mtr_number}</div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color ">
          Personal Liability insurance:
        </div>
        <div className="col-7 text-left black-color">
          {pli_file_path ? (
            <a href={S3baseUrl + pli_file_path} target="_blank">
              Personal Liability insurance{" "}
              <img
                style={{ width: 20, paddingLeft: 5 }}
                src={externalLinkImage}
              />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">
          Personal Damage Insurance:
        </div>
        <div className="col-7 text-left black-color">
          {pdi_file_path ? (
            <a href={S3baseUrl + pdi_file_path} target="_blank">
              Personal Damage Insurance
              <img
                style={{ width: 20, paddingLeft: 5 }}
                src={externalLinkImage}
              />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">
          Cargo Policy Insurance (Optional):
        </div>
        <div className="col-7 text-left black-color">
          {cpi_file_path ? (
            <a href={S3baseUrl + cpi_file_path} target="_blank">
              Cargo Policy Insurance
              <img
                style={{ width: 20, paddingLeft: 5 }}
                src={externalLinkImage}
              />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">
          General Liability Insurance (Optional):
        </div>
        <div className="col-7 text-left black-color">
          {gli_file_path ? (
            <a href={S3baseUrl + gli_file_path} target="_blank">
              General Liability Insurance
              <img
                style={{ width: 20, paddingLeft: 5 }}
                src={externalLinkImage}
              />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>{" "}
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">
          Workers compensation(Optional):
        </div>
        <div className="col-7 text-left black-color">
          {wc_file_path ? (
            <a href={S3baseUrl + wc_file_path} target="_blank">
              Workers compensation
              <img
                style={{ width: 20, paddingLeft: 5 }}
                src={externalLinkImage}
              />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2 pb-4">
        <div className="col-5 text-left dark-grey-color pt-2">Status:</div>
        <div className="col-7 ">
          {is_active ? (
            <>
              <div style={{ minWidth: 100 }}>
                <Radio checked style={{ color: "green", marginLeft: -15 }} />
                Active
              </div>
            </>
          ) : (
            <>
              <div style={{ minWidth: 100 }}>
                <Radio checked color="secondary" style={{ marginLeft: -15 }} />
                Inactive
              </div>
            </>
          )}
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="text-center status-buttons pb-40 text-center">
          {registeration_status ? (
            is_active ? (
              <span
                onClick={HitCompanyDeactivate}
                className="custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled active"
              >
                Deactive Company
              </span>
            ) : (
              <span
                onClick={HitCompanyActivate}
                className="custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
              >
                Active Company
              </span>
            )
          ) : (
            <span
              onClick={HitCompanyApprove}
              className="custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
            >
              Approve Company
            </span>
          )}
        </div>
      </div>
    </>
  );
}

export default UserCard;
